<template>
  <CounterSection style="margin-top: -10px;" />
  <div
    class="home w-full flex flex-col lg:flex-row items-start justify-center gap-6 lg:gap-10 px-4 lg:px-48 py-4 lg:py-10">
    <!-- Left Card -->
    <div class="w-full lg:w-1/3 bg-white rounded-xl shadow-md p-6 flex flex-col items-start text-gray-800">
      <div class="mb-4 w-full items-center justify-start flex">
        <p class="px-3 py-1 text-gray-500 font-medium text-2xl border-l-8 border-warning mb-2">
          EVENT DETAILS
        </p>
      </div>

      <!-- Date -->
      <div class="flex items-center mb-3 space-x-3">
        <div class="flex-shrink-0 bg-primary-light flex items-center justify-center rounded-full p-2 w-8 h-8">
          <img src="@/assets/icons/calendar_icon.svg" class="w-4 h-4 object-contain" />
        </div>
        <div class="flex-1">
          <p class="text-sm lg:text-base">
            {{ formattedDate }}
          </p>
        </div>
      </div>

      <!-- Location -->
      <div class="flex items-center mb-6 space-x-3">
        <div class="flex-shrink-0 bg-primary-light flex items-center justify-center rounded-full p-2 w-8 h-8">
          <img src="@/assets/icons/place_icon.svg" class="w-4 h-4 object-contain" />
        </div>
        <div class="flex-1">
          <p class="text-sm lg:text-base">
            {{ sched?.event_location || 'To be announced' }}
          </p>
        </div>
      </div>

      <ButtonControl v-if="isRegistrationOpen" @click="openModal('guest')" ref="guest" variant="primary" class="mb-3">
        REGISTER AS GUEST
      </ButtonControl>

      <ButtonControl v-else ref="guest" variant="primary" class="mb-3" disabled>
        REGISTRATION IS CLOSED
      </ButtonControl>

      <ButtonControl v-if="isRegistrationOpen" @click="openModal('member')" ref="member" variant="warning">
        REGISTER THROUGH MEMBER PORTAL
      </ButtonControl>
    </div>

    <!-- Poster -->
    <div class="w-full lg:w-2/3 bg-white rounded-xl shadow-md overflow-hidden p-5">
      <img src="https://resource.pafcpic.net/assets/funrun/papsi_run_poster.jpg" alt="Event Banner"
        class="w-full h-auto object-cover rounded" />
    </div>
  </div>

  <!-- Data Privacy Modal -->
  <transition name="slide-in">
    <ModalControl v-if="data_privacy_modal" :is_visible="data_privacy_modal" :width="'w-5/6 lg:w-1/2'"
      @close="data_privacy_modal = false">
      <DataPrivacyContent />
    </ModalControl>
  </transition>
</template>

<script>
import ModalControl from '@/components/controls/ModalControl.vue';
import DataPrivacyContent from '@/components/contents/DataPrivacyContent.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';
import CounterSection from '@/components/sections/CounterSection.vue';

export default {
  name: "HomeView",
  inject: ['setLoading'],
  components: {
    ModalControl,
    DataPrivacyContent,
    ButtonControl,
    CounterSection
  },
  data() {
    return {
      data_privacy_modal: false
    }
  },
  computed: {
    sched() {
      return this.$store.state.sched || {};
    },
    isDevelopmentMode() {
            return process.env.VUE_APP_DEVELOPMENT_MODE === 'true';
        },

    formattedDate() {
      if (!this.sched?.event_date) return "To be announced";

      const date = new Date(this.sched.event_date);
      const options = { year: "numeric", month: "long", day: "numeric" };

      // Example: "November 15, 2025 (Saturday)"
      const formattedDate = date.toLocaleDateString("en-US", options);
      const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
      return `${formattedDate} (${weekday})`;
    },


    isRegistrationOpen() {
      if (!this.sched?.registration_start || !this.sched?.registration_end) return false;

      const today = new Date();
      today.setHours(0,0,0,0); // normalize to start of day

      const start = new Date(this.sched.registration_start);
      start.setHours(0,0,0,0);

      const end = new Date(this.sched.registration_end);
      end.setDate(end.getDate() - 1); // day before
      end.setHours(0,0,0,0);

      return today >= start && today <= end;
    }


  },
  methods: {
    openModal(type) {
      if (type === 'member') {
        // window.open("http://192.168.3.191:8081/", "_blank");
        if (!this.isDevelopmentMode) {
          window.open("https://dev.memberportal.pafcpic.net/", "_blank");
        } else {
          window.open("https://memberportal.pafcpic.ph/", "_blank");
        }
      } else {
        this.$router.push('/registration');
        this.$store.state.form = null;
        this.$store.state.segment = null;
        this.$store.state.distance = null;
        this.$store.state.consent = null;
        this.$store.state.email = null;
        this.$store.state.editIndex = null;
        this.$store.state.fromConfirm = null;
      }
    }
  }
};
</script>

<style scoped>
.material-icons {
  font-size: 22px;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
